<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="mx-[31px]">
  <h4 class="development-title pl-[14px] items-center justify-center pt-[25px]">
    Expression of Interest
  </h4>

  <div
    class="header h-[55px] flex items-center pl-[14px] !mt-[17px] bg-[#F1F3F5] justify-between"
  >
    <div>
      <p class="!m-0">Project Brief</p>
    </div>
  </div>

  <div id="printForm" class="mx-[0px]">
    <div class="w-[100%] pb-[30px] pt-[40px]">
      <app-brief-section></app-brief-section>
    </div>
  </div>
  <div
    class="header h-[55px] flex items-center pl-[14px] mt-[30px] bg-[#F1F3F5] justify-between"
  >
    <div>
      <p class="!m-0">Selected Work Packages</p>
    </div>
  </div>
  <div id="printForm" class="mx-[0px]">
    <div class="w-[100%] pb-[30px] pt-[0px]">
      <app-selected-work-packages
        [inputData]="inputData"
      ></app-selected-work-packages>
    </div>
  </div>

  <div
    class="header h-[55px] flex items-center pl-[14px] mt-[30px] bg-[#F1F3F5] justify-between"
  >
    <p class="!m-0">Dates & Eligibility Criteria</p>
  </div>

  <div class="w-[100%] mt-[7px] ml-[12px]">
    <div class="w-[100%] flex justify-between items-center">
      <div class="flex justify-start">
        <p
          class="breif-value"
          [innerHTML]="getSanitizedHtml(initiatedEoiData?.eligibility_criteria)"
        ></p>
      </div>
    </div>
  </div>

  <div class="w-[100%] mt-[7px] ml-[12px]">
    <div
      class="flex justify-between w-[400px]"
      *ngIf="initiatedEoiData?.submission_date"
    >
      <p class="eligiiblity-date">EOI Submission Closing</p>
      <p class="eligiiblity-date-value">
        {{ transformDate(initiatedEoiData?.submission_date) }}
      </p>
    </div>
    <div
      class="flex justify-between w-[400px]"
      *ngIf="initiatedEoiData?.inquiry_deadline"
    >
      <p class="eligiiblity-date">EOI Deadline</p>
      <p class="eligiiblity-date-value">
        {{ transformDate(initiatedEoiData?.inquiry_deadline) }}
      </p>
    </div>
  </div>

  <div id="printForm" class="mx-[10px]">
    <div
      class="container-fluid flex justify-center h-auto p-[0px] !m-[3px] !mt-[5px]  !pb-[0px]"
    >
      <div class="!pb-0 w-full !pt-[0px]">
        <h3 class="text-[20px] font-semibold !pl-[0px] !pb-[20px] !mb-[0px]">
          Applicant Details
        </h3>
        <div
          class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 container"
        >
          <div class="container pr-5">
            <div class="rounded pr-10">
              <mat-form-field
                class="!w-[500px] !mb-[10px]"
                appearance="outline"
              >
                <mat-label> Company Name </mat-label>
                <input
                  matInput
                  formControlName="company_name"
                  placeholder="Company Name"
                />
              </mat-form-field>
              <div
                *ngIf="
                  formGroup.get('company_name').invalid &&
                  formGroup.get('company_name').touched
                "
                class="error-message"
              >
                <span style="color: red">Company Name is required</span>
              </div>
            </div>
          </div>
          <div class="container pr-5">
            <div class="rounded pr-10 !mb-[40px]">
              <mat-form-field
                class="!w-[500px] !mb-[10px]"
                appearance="outline"
              >
                <mat-label>Contact Person</mat-label>
                <input
                  matInput
                  formControlName="contact_person"
                  placeholder="Contact Person"
                />
              </mat-form-field>
              <div
                *ngIf="
                  formGroup.get('contact_person').invalid &&
                  formGroup.get('contact_person').touched
                "
                class="error-message"
              >
                <span style="color: red">Contact Person is required</span>
              </div>
            </div>
          </div>

          <div class="container pr-5">
            <div class="rounded pr-10 !mb-[40px]">
              <mat-form-field
                class="!w-[500px] !mb-[10px]"
                appearance="outline"
              >
                <mat-label>Company Registration Number</mat-label>
                <input
                  matInput
                  formControlName="company_reg_no"
                  placeholder="Company Registration Number"
                />
              </mat-form-field>
              <div
                *ngIf="
                  formGroup.get('company_reg_no').invalid &&
                  formGroup.get('company_reg_no').touched
                "
                class="error-message"
              >
                <span style="color: red"
                  >Company Registration Number is required</span
                >
              </div>
            </div>
          </div>
          <div class="container pr-5">
            <div class="rounded pr-10 !mb-[40px]">
              <mat-form-field
                class="!w-[500px] !mb-[10px]"
                appearance="outline"
              >
                <mat-label>Position</mat-label>
                <input
                  matInput
                  formControlName="contact_person_position"
                  placeholder="Position"
                />
              </mat-form-field>
              <div
                *ngIf="
                  formGroup.get('contact_person_position').invalid &&
                  formGroup.get('contact_person_position').touched
                "
                class="error-message"
              >
                <span style="color: red">Position is required</span>
              </div>
            </div>
          </div>

          <div class="container pr-5">
            <div class="rounded pr-10 !mb-[40px]">
              <mat-form-field
                class="!w-[500px] !mb-[10px]"
                appearance="outline"
              >
                <mat-label>VAT Registration Number</mat-label>
                <input
                  matInput
                  formControlName="company_vat_no"
                  placeholder="VAT Registration Number"
                />
              </mat-form-field>
              <div
                *ngIf="
                  formGroup.get('company_vat_no').invalid &&
                  formGroup.get('company_vat_no').touched
                "
                class="error-message"
              >
                <span style="color: red"
                  >VAT Registration Number is required</span
                >
              </div>
            </div>
          </div>
          <div class="container pr-5">
            <div class="rounded pr-10">
              <mat-form-field class="!w-[500px]" appearance="outline">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  formControlName="email"
                  type="email"
                  placeholder="Email"
                />
              </mat-form-field>
            </div>
          </div>

          <div class="container pr-5">
            <div class="rounded pr-10">
              <mat-form-field class="!w-[500px]" appearance="outline">
                <mat-label>Website</mat-label>
                <input
                  formControlName="website"
                  matInput
                  placeholder="Website"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="container pr-5">
            <div class="rounded pr-10">
              <mat-form-field class="!w-[500px]" appearance="outline">
                <mat-label>Telephone#</mat-label>
                <input
                  formControlName="phone"
                  matInput
                  type="text"
                  placeholder="Telephone#"
                />
              </mat-form-field>
            </div>
          </div>

          <div class="container pr-5 !h-[150px]">
            <div class="rounded pr-10">
              <mat-form-field
                class="!w-[500px] !h-[179px] !mb-[0px]"
                appearance="outline"
              >
                <mat-label>Address</mat-label>
                <input
                  formControlName="address"
                  matInput
                  placeholder="Address"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="container pr-5 !h-[150px]">
            <div class="rounded pr-10">
              <mat-form-field
                class="!w-[500px] !mb-[20px]"
                appearance="outline"
              >
                <mat-label>City</mat-label>
                <input formControlName="city" matInput placeholder="City" />
              </mat-form-field>
            </div>
            <div class="rounded pr-10 mt-[26px]">
              <mat-form-field class="!w-[500px] !mb-[0px]" appearance="outline">
                <mat-label>State/Province</mat-label>
                <input
                  formControlName="state"
                  matInput
                  placeholder="State/Province"
                />
              </mat-form-field>
            </div>
          </div>

          <div class="container pr-5 mt-[24px]">
            <div class="rounded w-[500px]">
              <app-country
                [country]="countryFromMap"
                (changeCountry)="updateCountry($event)"
              ></app-country>
            </div>
          </div>
          <div class="container pr-5 mt-[24px]">
            <div class="rounded pr-10">
              <mat-form-field class="!w-[500px]" appearance="outline">
                <mat-label>Zip/Postal Code</mat-label>
                <input
                  formControlName="zip"
                  matInput
                  placeholder="Zip/Postal Code"
                  maxlength="10"
                />
                <mat-error *ngIf="formGroup.get('zip')?.errors?.maxlength">
                  Maximum 10 characters allowed.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="container-fluid flex justify-center h-auto p-[0px] !pt-[0px] !m-[3px] !mt-[0px] !mb-[10px] !pb-[0px]"
    >
      <div class="!pb-0 w-full">
        <h3 class="text-[20px] font-semibold !pl-[0px] !pb-[20px] !mb-[0px] !pt-0">
          Experience & Capability (If Applicable)
        </h3>
        <div class="container">
          <!-- <h3 class="!pl-[60px] col-span-12">Applicant Details</h3> -->
            <div >
              <div class="rounded pr-10">
                <mat-form-field class="!w-full !h-[55px]" appearance="outline">
                  <mat-label>Relevant Experience</mat-label>
                  <textarea
                    matInput
                    [rows]="4"
                    formControlName="relevant_experience"
                    placeholder="Relevant Experience"
                  ></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="my-[2rem]">
              <app-file-manager
                [newFileControlName]="'relevantExperienceFileControl'"
                [oldFiles]="oldRelevantExperienceFiles"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>
            </div>
            <div class="rounded pr-10 mt-[1rem]">
              <mat-form-field class="!w-full !h-[55px]" appearance="outline">
                <mat-label>Key Qualifications</mat-label>
                <textarea
                  matInput
                  [rows]="4"
                  formControlName="qualifications"
                  placeholder="Key Qualifications"
                ></textarea>
              </mat-form-field>
            </div>
            <div class="my-[2rem]">
              <app-file-manager
                [newFileControlName]="'keyQualificationsFileControl'"
                [oldFiles]="oldkeyQualificationsFiles"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>
            </div>
            <div class="rounded pr-10 mt-[1rem]">
              <mat-form-field class="!w-full !h-[55px]" appearance="outline">
                <mat-label>Team Composition</mat-label>
                <textarea
                  formControlName="team_composition"
                  matInput
                  [rows]="4"
                  placeholder="Team Composition"
                > </textarea>
              </mat-form-field>
            </div>
            <div class="my-[2rem]">
              <app-file-manager
                [newFileControlName]="'teamCompositionFileControl'"
                [oldFiles]="oldTeamCompositionFiles"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>
            </div>
        </div>
      </div>
    </div>

    <div
      class="container-fluid flex justify-center h-auto p-[0px] !pt-[0px] !m-[3px] !mt-[0px] !mb-[10px] !pb-[0px]"
    >
      <div class="!pb-0 w-full">
        <h3 class="text-[20px] font-semibold !pt-0 !pb-[20px] !pl-[0px] !mb-[0px]">
          Compliance & Policies
        </h3>
        <div class="grid grid-cols-1 gap-4 container">
          <!-- <h3 class="!pl-[60px] col-span-12">Applicant Details</h3> -->

          <div class="container">
            <div class="rounded pr-10">
              <mat-form-field class="!w-full !h-[55px]" appearance="outline">
                <mat-label>Health, Safety & Environmental Policy</mat-label>
                <textarea
                  formControlName="health_safety_environmental_policy"
                  matInput
                  [rows]="4"
                  placeholder="Health, Safety & Environmental Policy"
                >
                </textarea>
              </mat-form-field>
            </div>
            <div class="my-[2rem]">
              <app-file-manager
                [newFileControlName]="'healthAndSafetyFileControl'"
                [oldFiles]="oldHealthAndSafetyFiles"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>
            </div>
            <div class="rounded pr-10 mt-[2.5rem]">
              <mat-form-field class="!w-full !h-[px]" appearance="outline">
                <mat-label>Quality Assurance Certification</mat-label>
                <textarea
                  formControlName="quality_assurance_cert_attach"
                  matInput
                  [rows]="4"
                  placeholder="Quality Assurance Certification"
                ></textarea>
              </mat-form-field>
            </div>
            <div class="my-[2rem]">
              <app-file-manager
                [newFileControlName]="'qualityAssuranceFileControl'"
                [oldFiles]="oldQualityAssuranceFiles"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>
            </div>

            <div class="rounded pr-10 mt-[2.5rem]">
              <mat-form-field class="!w-full !h-[75px]" appearance="outline">
                <mat-label>Conflict of Interest Disclosure</mat-label>
                <textarea
                  formControlName="conflict_of_interest"
                  matInput
                  [rows]="4"
                  placeholder="Conflict of Interest Disclosure"
                >
                </textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- additional informaton -->
    <div
      class="container-fluid flex justify-center h-auto p-[0px] !pt-[0px] !m-[3px] !mt-[0px]  !pb-[0px]"
    >
      <div class="!pb-0 w-full">
        <h3 class="text-[20px] font-semibold !pl-[0px] !pb-[20px] !mb-[0px]">
          Additional Information
        </h3>
        <div class="container">
          <div class="rounded pr-10">
            <mat-form-field class="!w-[100%]" appearance="outline">
              <mat-label>Additional Information</mat-label>
              <textarea
                formControlName="additional_information"
                [rows]="4"
                matInput
                placeholder="Additional Information"
              >
              </textarea>
            </mat-form-field>
          </div>
          <div class="my-[2rem]">
            <app-file-manager
              [newFileControlName]="'additionalInformationControl'"
              [oldFiles]="oldAdditionalInformationFiles"
              (newFilesUpdatedEvent)="handleNewFiles($event)"
              (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
            ></app-file-manager>
          </div>
        </div>
      </div>
    </div>

    <div
      class="container-fluid flex justify-center h-auto p-[0px] !pt-[0px] !m-[3px] !mt-[0px] !mb-0 !pb-[0px]"
    >
      <div class="!pb-0 w-full">
        <h3 class="text-[20px] font-semibold  !pl-[0px] !pb-[20px] !pt-0 !mb-[0px]">
          Declaration
        </h3>
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 container">
          <!-- <h3 class="!pl-[60px] col-span-12">Applicant Details</h3> -->

          <div class="container pr-5">
            <div class="rounded pr-10 !mb-[40px]">
              <mat-form-field
                class="!w-[500px] !mb-[10px]"
                appearance="outline"
              >
                <mat-label>Name of Authorized Representative</mat-label>
                <input
                  formControlName="authorized_representative"
                  matInput
                  placeholder="Name of Authorized Representative"
                />
              </mat-form-field>
              <div
                *ngIf="
                  formGroup.get('authorized_representative').invalid &&
                  formGroup.get('authorized_representative').touched
                "
                class="error-message"
              >
                <span style="color: red"
                  >Authorized Representative Name is required</span
                >
              </div>
            </div>
          </div>
          <div class="container pr-5">
            <div class="rounded pr-10 !mb-[40px]">
              <mat-form-field
                class="!w-[500px] !mb-[10px]"
                appearance="outline"
              >
                <mat-label>Position</mat-label>
                <input
                  formControlName="authorized_representative_position"
                  matInput
                  placeholder="Position"
                />
              </mat-form-field>
              <div
                *ngIf="
                  formGroup.get('authorized_representative_position').invalid &&
                  formGroup.get('authorized_representative_position').touched
                "
                class="error-message"
              >
                <span style="color: red"
                  >Representative Position is required</span
                >
              </div>
            </div>
          </div>

          <div class="container pr-5">
            <div class="rounded pr-10 !mb-[40px]">
              <mat-form-field
                class="!w-[500px] !mb-[10px]"
                appearance="outline"
              >
                <mat-label>Signature</mat-label>
                <input
                  formControlName="signature"
                  matInput
                  placeholder="Signature"
                />
              </mat-form-field>
              <div
                *ngIf="
                  formGroup.get('signature').invalid &&
                  formGroup.get('signature').touched
                "
                class="error-message"
              >
                <span style="color: red">Signature is required</span>
              </div>
            </div>
          </div>

          <div class="container pr-5">
            <div class="rounded pr-10 !mb-[40px]">
              <mat-form-field
                class="!w-[500px] !mb-[10px]"
                type="date"
                appearance="outline"
              >
                <mat-label>Date</mat-label>
                <input
                  formControlName="date"
                  matInput
                  placeholder="Date"
                  [matDatepicker]="signedDate"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="signedDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #signedDate startView="year"></mat-datepicker>
              </mat-form-field>
              <div
                *ngIf="
                  formGroup.get('date').invalid && formGroup.get('date').touched
                "
                class="error-message"
              >
                <span style="color: red">Date is required</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h3 class="text-[20px] !pt-[0px] !pb-[10px] font-semibold !pl-[0px] !mb-[0px]">
      Disclaimer
    </h3>
    <p class="breif-value pl-[3px]">
      This Expression of Interest (EOI) document has been prepared by OQ
      Alternative Energy solely for the benefit of OQ Alternative Energy. This
      document contains confidential and legally privileged information and may
      not be disclosed to, or relied upon by, any person or entity other than OQ
      Alternative Energy without the prior written consent of OQ Alternative
      Energy. Any recipient of this document is required to treat it as
      confidential and may not disclose it to any third parties other than its
      technical, financial, insurance, tax, and accounting teams, and only to
      the extent that: (i) such disclosure is necessary for the purpose of
      responding to this EOI; (ii) the recipient makes these parties aware of
      the confidential nature of this information; (iii) the receiving parties
      are subject to professional or legal obligations to maintain the
      confidentiality of such information. OQ Alternative Energy does not assume
      any duty or responsibility to any person or entity with respect to the
      information contained in this EOI, whether in contract, tort, statute, or
      otherwise, including negligence. Recipients of this document shall not
      rely upon the information for any purpose other than the submission of an
      expression of interest as described in this document.
    </p>
  </div>

  <div class="container-fluid p-[29px] !pr-[35px] !mt-[5px] bg-[#ffffff]">
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
      <div class="rounded flex justify-end">
        <button
          type="button"
          (click)="handleCLose()"
          class="back-button !mr-[10px]"
        >
          Back
        </button>
        <button type="submit" class="save-button">Submit</button>
      </div>
    </div>
  </div>
</form>
